import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { TabRow } from 'lib/designSystem/TabSimulation';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { validatePermissions } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AuthState } from 'services/redux/authSlice';

import MyWalletCessions from './components/Cessions';
import ClientSummary from './components/ClientSummary';
import MyWalletConcentrations from './components/Concentrations';
import PayerSales from './components/PayerSales';
import MyWalletSummary from './components/Summary';
import TeamSummary from './components/TeamSummary';

const MyWallet = () => {
  const { page } = useParams<{
    id: string;
    businessId: string;
    page: string;
  }>();
  const [loading, setLoading] = useState(true);
  const [companyTabs, setCompanyTabs] = useState<TabRow[]>([]);

  const [startValue, setStartValue] = useState(0);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const tabs = [
    {
      id: 1,
      label: 'Resumen',
      component: <MyWalletSummary />,
      path: 'summary',
    },
    ...(validatePermissions(user, 'have_subordinates')
      ? [
          {
            id: 2,
            label: 'Equipo',
            component: <TeamSummary />,
            path: 'team',
          },
        ]
      : []),
    {
      id: 3,
      label: 'Cesiones',
      component: <MyWalletCessions />,
    },
    {
      id: 4,
      label: 'Concentraciones',
      component: <MyWalletConcentrations />,
    },
    {
      id: 5,
      label: 'Fact. Deudor',
      component: <PayerSales />,
    },
    {
      id: 6,
      label: 'Resumen Clientes',
      component: <ClientSummary />,
    },
  ];

  const setUpTabs = async () => {
    const newProfileTabs = [...tabs];
    let startValueDefault = 0;
    startValueDefault = newProfileTabs.findIndex((x) => x.path === page);
    setCompanyTabs(newProfileTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    void setUpTabs();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <EnhancedTab
      tabType="secondary"
      startValue={startValue}
      tabs={companyTabs}
    />
  );
};

export default MyWallet;
